import { render, staticRenderFns } from "./settingsSvg.vue?vue&type=template&id=0a55c847&"
import script from "./settingsSvg.vue?vue&type=script&lang=js&"
export * from "./settingsSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports